<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>收款信息</span>
      </div>
      <el-form label-width="90px" style="padding:16px 30px 0 30px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="客户名称：" :rules="filter_rules({required:true})">
              <span>{{ queryParams.cusName }}</span>
              <el-button
                @click="onSelectCustomer"
                type="text"
                icon="el-icon-refresh"
                v-if="queryParams.cusName"
              >选择客户</el-button>
              <el-button @click="onSelectCustomer" type="text" icon="el-icon-plus" v-else>选择客户</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款类型：" :rules="filter_rules({required:true})">
              <el-select v-model="queryParams.receiptType">
                <el-option
                  v-for="(item,index) in receiptTypeList"
                  :key="index"
                  :label="item.lab"
                  :value="item.val"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收款方式：承兑汇票  "
              label-width="170px"
              :rules="filter_rules({required:true})"
            >
              <el-input placeholder="请输入票据金额" v-model="queryParams.money" @change="onInput"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注：" :rules="filter_rules({required:true})">
              <el-input
                maxlength="150"
                show-word-limit
                type="textarea"
                :rows="3"
                v-model.number="queryParams.mark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="total">
          本次总计收款：
          <span style="color:#D35E5E" v-if="queryParams.money">{{queryParams.money}}</span>
        </div>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>承兑汇票</span>
      </div>
      <el-form label-width="90px" style="padding:16px 30px 0 30px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="承兑票号：" :rules="filter_rules({required:true})">
              <el-input placeholder="请填写承兑票号" v-model="queryParams.billNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票单位：" :rules="filter_rules({required:true})">
              <el-input v-model="queryParams.billCompany" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票银行：" :rules="filter_rules({required:true})">
              <el-input placeholder="请填写出票银行名称" v-model="queryParams.billBank"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="出票日期：" :rules="filter_rules({required:true})">
              <el-date-picker v-model="queryParams.billDate" type="date" placeholder="请选择出票日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="到期日期：" :rules="filter_rules({required:true})">
              <el-date-picker
                v-model="queryParams.billEnddate"
                type="date"
                placeholder="请选择到期日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="上传凭证：">
            <div class="upload-pictures">
              <el-upload
                action="Fake Action"
                :on-success="allHandleSuccess"
                :on-change="handleChange"
                :before-upload="beforeUploadFile"
                :on-remove="handleRemove"
                :http-request="allUpload"
                multiple
                :limit="1"
                class="upload-demo"
                drag
                ref="upload"
                :file-list="fileList"
                :on-exceed="onExceed"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div>支持上传pdf、png和jpeg，最多可上传1个附件且不超过10M</div>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div style="margin-left:20px">
      <el-button @click="onInitiateCollection" type="primary">发起收款</el-button>
    </div>
    <!-------------- 调用客户 ------------>
    <customer-call-dialog @onRefresh="onRefresh" ref="customerCallDialogRefs" :isfinish="true"></customer-call-dialog>
    <!------------ 发起收款二次弹窗 ------------>
    <open-or-close
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import customerCallDialog from '../../../dialog/customerCallDialog'
import OpenOrClose from '@/components/OpenOrClose/index'
import { financeAcceptanceBillRequestSave } from '@/api/sell/sellManage'
// import { deepClone } from '@/util'
import { financeUploadFile } from '@/api/fiance/fianceManage'
export default {
  components: {
    'customer-call-dialog': customerCallDialog,
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      fileList: [],
      ruleForm: [],
      uploadFileType: ['pdf', 'png', 'jpeg'],
      receiptTypeList: [
        { lab: '销售货款', val: '销售货款' },
        { lab: '罚没金收款', val: '罚没金收款' },
        { lab: '维修收款', val: '维修收款' }
      ],
      list: [],
      // rules: [{ required: true, message: '不能为空' }],
      title: '',
      content: '',
      queryParams: {
        cusName: '',
        billCompany: '',
        receiptClass: '承兑汇票',
        money: null
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  methods: {
    onInput() {
      const str = /(^[¥]?[1-9]\d{0,2}($|(,\d{3})*($|(\.\d{1,2}$))))|((^[0](\.\d{1,2})?)|(^[¥][0]\.\d{1,2}))$/
      const str1 = /^([1-9]+[\d]*(.[0-9]{1,2})?)$/
      if (str.test(this.queryParams.money)) {
        return true
      } else if (str1.test(this.queryParams.money)) {
        return true
      } else {
        this.queryParams.money = ''
      }
    },
    onExceed() {
      this.$message.error('至多上传1个文件！')
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((item) => {
        return item.id !== file.id
      })
      this.ruleForm = this.ruleForm.filter((items) => {
        return items.guid !== file.id
      })
    },
    beforeUploadFile(file) {
      const { uploadFileType } = this
      const filearr = file.name.split('.')
      const filetype = filearr[filearr.length - 1]
      if (file.size === 0) {
        this.$message.error('文件内容为空')
        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('文件过大')
        return false
      }
      if (uploadFileType.includes(filetype)) {
        return true
      }
      this.$message.error('请上传正确的文件')
      return false
    },
    async allUpload() {
      var formData = new FormData()
      const { fileList } = this
      const len = fileList.length - 1
      formData.append('MultipartFile[]', fileList[len].raw)
      await financeUploadFile(formData).then((res) => {
        if (res.data.code === 200) {
          this.ruleForm.push(...res.data.obj)
          Object.assign(this.fileList[len], {
            id: res.data.obj[0].guid
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    allHandleSuccess() {},
    // 选择客户
    onSelectCustomer() {
      this.$refs.customerCallDialogRefs.onInitial()
    },
    // 确认调用客户
    onRefresh(params) {
      this.queryParams.cusName = params.cusName
      this.queryParams.cusId = params.id
      this.queryParams.billCompany = params.cusName
    },
    // 发起收款
    onInitiateCollection() {
      if (!this.queryParams.cusId) {
        this.$message.error('请选择客户')
        return
      }
      if (!this.queryParams.money || this.queryParams.money < 0) {
        this.$message.error('请输入正确的收款金额')
        return
      }
      if (
        !this.queryParams.receiptType ||
        !this.queryParams.billNumber ||
        !this.queryParams.billBank ||
        !this.queryParams.billDate ||
        !this.queryParams.billEnddate ||
        !this.queryParams.mark
      ) {
        this.$message.error('请把数据填写完整')
        return
      }
      this.title = '收款申请确认'
      this.content = `本次收款金额总计：${this.queryParams.money}元确定提交收款申请？`
      this.$refs.openOrCloseRefs.onInitial(this.content)
    },
    // 确认发起收款
    onUpdataState() {
      if (!this.queryParams.money) {
        this.$message.error('请输入收款金额')
        return
      }
      // this.ruleForm.forEach((ele) => {
      //   ele.attachment = ele.guid
      // })
      this.queryParams.financePayRequestAttachmentList = this.ruleForm.map((item) => {
        return Object.assign(item, {
          attachment: item.guid
        })
      })
      financeAcceptanceBillRequestSave(this.queryParams)
        .then((res) => {
          if (res.data.code === 200) {
            this.$router.push({ name: 'acceptDraftCollections' })
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.total {
  height: 48px;
  line-height: 48px;
  color: #4e555b;
  background: #f3f7ff;
  border-radius: 4px;
  padding-left: 20px;
}
</style>
